import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.scss";
import { useGetBrandByIdQuery } from "../../../../services/productsAPI"

function Index({ product }) {
  const [key, setKey] = useState("home");
  const { data: brandData } = useGetBrandByIdQuery(product?.brand_id);
  console.log("brandData", brandData)

  return (
    <div className="container mt-4">
      {(product.detailed_description || product.additional_info) && <div className="product-description">
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
          {product.detailed_description && <Tab eventKey="home" title="Description">
            <div className="row align-items-start">
              {/* Conditionally render the image only if it exists */}
              {product.product_extra_description_url && (
                <div className="col-md-2">
                  {/* Display the extra description image on the left side */}
                  <img
                    src={product.product_extra_description_url}
                    alt="Extra Description"
                    className="img-fluid"
                  />
                </div>
              )}
              {/* Display the HTML content */}
              <div className="col-md-10">
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.detailed_description,
                  }}
                />
              </div>
            </div>
          </Tab>}
          {product.additional_info && <Tab eventKey="additionalInformation" title="Additional Information">
            <p>{product.additional_info}</p>
          </Tab>}

          {product.detailed_description && product?.brand_id && <Tab eventKey="aboutbrand" title="About brand">
            <div className="row">
              <div className="col-md-4 col-sm-12 col-lg-4">
                <img src={brandData?.brand?.image} alt="brand-img" />
              </div>
              <div className="col-md-8 col-sm-12 col-lg-8">
                <h4>{brandData?.brand?.name}</h4>
                <p>{brandData?.brand?.description}</p>
              </div>
            </div>
          </Tab>}

        </Tabs>
      </div>}
    </div>
  );
}

export default Index;
